import type { IconSvgObject } from './types';

const MouseLeftIcon: IconSvgObject = [
  ["path", { d: "M12.7422 8.5V5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.7422 2.0449C12.0607 2.0152 12.3939 2 12.7422 2C18.7422 2 20.2422 6.50998 20.2422 12C20.2422 17.49 18.7422 22 12.7422 22C6.74212 22 5.24219 17.49 5.24219 12C5.24219 11.3158 5.26548 10.6469 5.31788 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "5.74219", cy: "4", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MouseLeftIcon;
